import React, { Component } from "react";
import { connect } from "react-redux";
import { showMessageModal, showChildSideBar, hideChildSideBar, hideSideBar } from "../../../redux/actions/miscActions";
import { savePakketToDatabase, addPakketProducts } from "../../../redux/actions/productActions";
import { OWNER_NAME, CLIENT_ID } from "../../../utils/config";
import { Form, Input, Drawer, Select, InputNumber} from "antd";
import { single, multiple } from "../../../utils/Eenheden";
import PakketProducts from "./PakketProducts";

const { Option } = Select;

export class PakketForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgPreview: "",
      productImage: '',
      pakketNaam: "",
      productCategorie: "pakket",
      typePakket: "",
      pakketPrijs: "",
      productId: "",
      volgNum: '',
      pakketOnSale: false,
      producten: [],
      isVisible: false,
      childrenDrawer: false,
      productOwner: CLIENT_ID,
      ownerName: OWNER_NAME,
    };
  }

  handleImageSelect = (e) => {
    if (e.target.files.length === 1) {
      const imgPreview = URL.createObjectURL(e.target.files[0]);
      this.setState({
        imgPreview,
        productImage: e.target.files[0],
      });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNumberInput = (e) => {
    if (e.target.value.match(/^[0-9]+([0-9,]{1,3})?$/gm)) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    } else if (e.target.value.length === 0) {
      this.setState({
        [e.target.name]: "",
      });
    }
  };

  handleFormSave = () => {
    const {
      productImage,
      pakketNaam,
      productCategorie,
      typePakket,
      pakketPrijs,
      productId,
      volgNum,
      pakketOnSale,
      isVisible,
      productOwner,
      ownerName,
    } = this.state;
    const { pakketProducts } = this.props.products;

    const feedback = {
      type: "loading",
      txt: "Aan het opslaan",
    };
    this.props.showMessageModal(feedback);
      
      const data = {
        productImage,
        pakketNaam,
        productCategorie,
        typePakket,
        pakketPrijs: pakketPrijs.replace(/,/g, "."),
        productId,
        volgNum,
        pakketOnSale,
        isVisible,
        productOwner,
        ownerName,
        producten: pakketProducts
      }
      this.props.savePakketToDatabase(data);    

  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.misc.messageType === "success") {
      this.props.addPakketProducts([])
      this.props.hideSideBar()
    }
  };


  showChildrenDrawer = () => {
    this.props.showChildSideBar('pakketten-form')
  };

  onClose=()=>{
    this.props.hideChildSideBar()
  }

  handleCatSelect = (value) => {
    this.setState({
      typePakket: value,
    });
  };


  render() {
    const {
      pakketNaam,
      typePakket,
      pakketPrijs,
      productId,
      volgNum,
      imgPreview
    } = this.state;

    const { isChildSideBarVisible, childSideBarContent } = this.props.misc
    const { pakketProducts } = this.props.products;

    const listedProducts = pakketProducts.map(x => {return(
      <li key={x.id} className="listed-products">
        {x.aantalNum} x {x.aantalNum > 1 ? multiple[x.productEenheid] : single[x.productEenheid]} {x.productNaam}
      </li>
    )})


    return (
      <div className="new-pakket-form">
        <Form layout="vertical">
        <Form.Item label="Pakket foto">
            <div className="image-preview">
              <img src={imgPreview} alt="" />
              <Input
                type="file"
                className="form-control-file"
                onChange={this.handleImageSelect}
              />
            </div>
          </Form.Item>

          <Form.Item label="Pakket naam" required={true}>
            <Input
              name="pakketNaam"
              onChange={this.handleInput}
              value={pakketNaam}
            />
          </Form.Item>

          <div className="prijzen-input">
            <Form.Item label="Prijs" required={true}>
              <Input
                prefix="SRD"
                name="pakketPrijs"
                onChange={this.handleNumberInput}
                value={pakketPrijs}
              />
            </Form.Item>
          </div>

          <Form.Item label="Pakket categorie" required={true}>
            <Select value={typePakket} onChange={this.handleCatSelect}>
              <Option value="healthy_greans_small">Healthy greans small</Option>
              <Option value="healthy_greans_medium">Healthy greans medium</Option>
              <Option value="healthy_greans_large">Healthy greans large</Option>
            </Select>
          </Form.Item>

          
          <div className="prijzen-input">

          <Form.Item
            label="Pakket ID"
            required={true}
            >
            <Input
              name="productId"
              onChange={this.handleInput}
              value={productId}
              />
          </Form.Item>

          <Form.Item
            label="Volg nummer"
            required={true}
            >
            <Input
              name="volgNum"
              onChange={this.handleInput}
              value={volgNum}
              />
          </Form.Item>
              </div>
          <Drawer
            key={childSideBarContent}
            closable={false}
            onClose={this.onClose}
            visible={isChildSideBarVisible}
            className="child-sidebar"
            destroyOnClose={true}
          >
            { childSideBarContent === 'pakketten-form' ? <PakketProducts /> : null}
          </Drawer>
          <ul className="listed-products">
          {listedProducts}
          </ul>
          <button className="add-products-button" onClick={this.showChildrenDrawer}>Producten selecteren</button>
          <button onClick={this.handleFormSave} className="large-main-btn">
            Opslaan
          </button>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  misc: state.misc,
});

export default connect(mapStateToProps, {showChildSideBar, hideChildSideBar, showMessageModal, hideSideBar, savePakketToDatabase, addPakketProducts})(PakketForm);
